import Color from '@tiptap/extension-color';

export function rgbStyleToHex(color: string | null): string | null {
	if (!color || color.indexOf('rgb') < 0) {
		return color;
	}

	if (color.charAt(0) === '#') {
		return color;
	}

	const nums = /(.*?)rgb\((\d+),\s*(\d+),\s*(\d+)\)/i.exec(color);
	if (!nums) {
		return color;
	}
	const r = Number.parseInt(nums[2], 10).toString(16);
	const g = Number.parseInt(nums[3], 10).toString(16);
	const b = Number.parseInt(nums[4], 10).toString(16);

	return (
		'#' +
		((r.length === 1 ? '0' + r : r) + (g.length === 1 ? '0' + g : g) + (b.length === 1 ? '0' + b : b))
	).toUpperCase();
}

export const ColorExtension = Color.extend({
	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					color: {
						default: null,
						parseHTML: (element) => element.style.color?.replace(/['"]+/g, ''),
						renderHTML: (attributes) => {
							if (!attributes.color) {
								return {};
							}

							return {
								style: `color: ${rgbStyleToHex(attributes.color)}`,
							};
						},
					},
				},
			},
		];
	},
});
